export const removeDropdown = () => {
  const dropdownInside = document.querySelector<HTMLElement>(
    ".dropdown-custom.active.visible"
  );

  if (!dropdownInside) {
    return;
  }

  dropdownInside.click();
};
